var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-screen"},[_c('button',{on:{"click":function($event){return _vm.handleView("next-restart")}}},[_vm._v("Go Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }